<nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-left ps-1 pe-0">
  @if (user) {
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav pe-2 pt-sm-5">
        <li class="nav-item text-center py-md-3 py-xl-3" routerLinkActive="active" ngbDropdown display="dynamic">
          <a class="nav-link px-0 active" tabindex="-1" aria-disabled="true" ngbDropdownToggle>
            <div class="d-flex flex-column">
              <fa-icon class="d-block" icon="user-circle" size="2x"></fa-icon>
              <small class="text-capitalize"> {{ user.firstname }}</small>
              <small class="text-uppercase fw-bold">{{ user.lastname }}</small>
            </div>
          </a>
          <div class="rounded-0" ngbDropdownMenu aria-labelledby="dropdownConfig">
            <button type="button" class="text-secondary" ngbDropdownItem routerLink="/dashboard/profile">
              <fa-icon icon="user" class="me-2"></fa-icon>Profil
            </button>
            <div class="dropdown-divider"></div>
            <button type="button" class="text-secondary" ngbDropdownItem (click)="editSignature()">
              <fa-icon icon="pen-nib" class="me-2"></fa-icon>Signature
            </button>
            <div class="dropdown-divider"></div>
            @if (pcAccountUrl) {
              <a href="{{ pcAccountUrl }}" rel="noopener" target="_blank" class="text-secondary ms-3" style="text-decoration: none">
                <fa-icon icon="lock" class="me-2"></fa-icon>Mon profil ProConnect
              </a>
            }
            <div class="dropdown-divider"></div>
            <button type="button" class="text-secondary" ngbDropdownItem (click)="disconnect()" routerLink="/login">
              <fa-icon icon="power-off" class="me-2"></fa-icon>Déconnexion
            </button>
          </div>
        </li>
        <li class="nav-item text-center py-md-1 py-xl-2">
          <a class="nav-link px-0" routerLink="/dashboard" routerLinkActive="active">
            <fa-icon class="d-none d-lg-block" icon="home" size="2x"></fa-icon>Tableau de bord
          </a>
        </li>
        <li class="nav-item text-center py-md-1 py-xl-2" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'RECEPTION', 'TERRITORY', 'DIRECTION', 'DIRECTION+']">
          <a class="nav-link px-0" routerLink="/beneficiaries" routerLinkActive="active">
            <fa-icon class="d-none d-lg-block" icon="users" size="2x"></fa-icon>Bénéficiaires
          </a>
        </li>
        <li class="nav-item text-center py-md-1 py-xl-2" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION', 'DIRECTION+']">
          <a class="nav-link px-0" routerLink="/agenda" routerLinkActive="active">
            <fa-icon class="d-none d-lg-block" icon="calendar-alt" size="2x"></fa-icon>Agenda
          </a>
        </li>
        <li class="nav-item text-center py-md-1 py-xl-2" *hasPermission="'INBOX_CAN_ACCESS'; context: 'INBOX'">
          <a class="nav-link px-0" routerLink="/inbox" routerLinkActive="active">
            <fa-icon class="d-none d-lg-block" icon="inbox" size="2x"></fa-icon>Bannette
          </a>
        </li>
        <li class="nav-item text-center py-md-1 py-xl-2" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+', 'MMIE']">
          <a class="nav-link px-0" routerLink="/community-action" routerLinkActive="active">
            <fa-icon class="d-none d-lg-block" icon="chalkboard-teacher" size="2x"></fa-icon>Actions et ateliers
          </a>
        </li>
        <li class="nav-item text-center py-md-1 py-xl-2">
          <a class="nav-link px-0" routerLink="/queries" routerLinkActive="active">
            <fa-icon class="d-none d-lg-block" icon="database" size="2x"></fa-icon>Requêtes
          </a>
        </li>
        <li class="nav-item text-center py-md-1 py-xl-2" *appOnlyGroups="['ADMIN']">
          <a class="nav-link px-0" routerLink="/admin" routerLinkActive="active">
            <fa-icon class="d-none d-lg-block" icon="cogs" size="2x"></fa-icon>Admin
          </a>
        </li>
      </ul>
    </div>
  }
</nav>
